import get from 'lodash/get';
import { selectIsUserSubscribed } from '../../selectors/me';
import { isProfile } from '../guideItemTypes';
import {
  selectIsPlaying,
  selectNowPlayingCanShowAds,
} from '../../selectors/player';

export function getStoreGuideItem(guideId, state) {
  return isProfile(guideId)
    ? state.profiles[guideId]
    : state.categories[guideId];
}

/**
 * Determines whether ads are appropriate for the user/context. While Mint also
 * makes this determination, this function is primarily used to prevent ad-related
 * elements from rendering (i.e., containers), which Mint has no way to control.
 * Eventually, Mint's ad eligibility logic should be replaced in favor of this function.
 *
 * @param {object} state - redux store state
 * @param {string|object} guideIdOrGuideItem
 * @returns {boolean}
 */
export default function determineAdEligibility(guideIdOrGuideItem) {
  return (state) => {
    if (selectIsUserSubscribed(state)) {
      return false;
    }

    const guideItem =
      typeof guideIdOrGuideItem === 'string'
        ? getStoreGuideItem(guideIdOrGuideItem, state)
        : guideIdOrGuideItem;
    const isPageAdEligible = get(
      guideItem?.metadata?.properties?.ads,
      'adEligible',
      true,
    );
    const isPlaying = selectIsPlaying(state);
    const isStreamAdEligible = selectNowPlayingCanShowAds(state, true);

    return isPageAdEligible && (!isPlaying || isStreamAdEligible);
  };
}
